import { FlowStepRunner } from "../../../rule-engine-core/Flow/Steps/FlowStepRunner";
import { FormStep } from "../../../rule-engine-core/Flow/Steps/UI/FormStep";
import { IUserInfo } from "../../../rule-engine-core/Plugins/DataStorage/IUserInfo";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { FlowStepTestContext } from "../../../rule-engine-core/Flow/Structure/FlowTestingContext";
import { FlowExecutionData } from "../../../rule-engine-core/Flow/Engine/FlowExecutionData";
import { FormConfiguration } from "../../../Form/FormConfiguration";
import { FormTestResult } from "../../../Form/Structure/FormTestResult";
import { EventLog } from "../../../rule-engine-core/Common/Event/EventLog";
import { FormRuntime } from "../../../Form/FormRuntime";
import { FormHost } from "../../../rule-engine-core/Common/Execution/IFormHost";
import { FlowEngine } from "../../../rule-engine-core/Flow/Engine/FlowEngine";
import React from "react";

export class ClientFormStepRunner extends FlowStepRunner<FormStep> {
    async start(
        user: IUserInfo,
        thread: string,
        executionData: ExecutionData,
        flowExecutionData: FlowExecutionData,
        testContext: FlowStepTestContext | undefined,
    ): Promise<void> {
        let form = new FormConfiguration();
        if (!this.stepData?.formData) throw new Error("Form data not supplied");
        form.setStorageData(this.stepData!.formData!);

        let subContext: FormTestResult | undefined;

        if (testContext) {
            subContext = new FormTestResult(form, executionData);
            // todo: put this back?
            // if (!formHost) {
            //     FormHost.defaultFormHost = subContext;
            //     formHost = subContext;
            // }
            testContext.addTestResultItem(subContext);
            subContext.addLogItem(new EventLog(`Form: start evaluating`));
        }

        let formHost = FormHost.defaultFormHost;

        if (!formHost) {
            throw new Error("No form host was defined. A form host is needed to allow ui to show a form.");
        }

        let renderId = flowExecutionData.flowExecutionId + "--" + thread + "--" + this.stepData!._id;
        if (formHost) {
            formHost.renderUI({
                renderId: renderId,
                renderUI: () => (
                    <FormRuntime
                        form={form}
                        onFormButtonClick={(buttonName: string, _data: ExecutionData) => {
                            // todo: put the form data back into data...
                            formHost!.close(renderId);
                            FlowEngine.stepComplete(
                                user,
                                flowExecutionData,
                                thread,
                                this.stepData!,
                                buttonName,
                                testContext,
                            );
                        }}
                        onFormClose={() => {
                            //     // todo: if cancel is an option... go there...
                            //     // else create assignment
                            formHost!.close(renderId);
                        }}
                        formData={executionData}
                        formTitle={"my form"}
                    />
                ),
                title: "",
                size: undefined,
                fullScreen: undefined,
            });
        } else {
            throw new Error("no form host");
        }

        return Promise.resolve(undefined);
    }
}
